var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('project-page',{attrs:{"uid":_vm.uid},on:{"onEndTo":function($event){return _vm.$emit('onEndTo', $event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }